import React, { useState } from "react";
import { IoMenu, IoClose } from "react-icons/io5";
// import Button from "../components/Button";
import { useNavigate } from "react-router-dom";
import Logo from "../assets/images/moneyratefinderLogo.svg";

const options = [
  {id: 0, label:"TRANSFER HOTSPOT", route:"/send-money-to"}, // Changes done by Alam
  { id: 1, label: "COMPARISON", route: "/comparison/worldremit-vs-wise" },
  { id: 2, label: "ABOUT", route: "/about" },
  { id: 3, label: "FAQ", route: "/faq" },
  // { id: 4, label: "PRIVACY&POLICY", route: "/privacy-policy" },
];

const Header = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const navigate = useNavigate();

  const handleMenuToggle = () => {
    setIsMobileMenuOpen((prev) => !prev);
  };

  const handleNavigation = (route) => {
    navigate(route);
    setIsMobileMenuOpen(false);
  };

  return (
    <div className="flex px-[20px] md:px-[40px] lg:px-[60px] justify-between items-center h-[68px] fixed w-full top-0 left-0 z-[99999] py-4 bg-[#FFFFFF] shadow-md shadow-[#d9bcff]">
      {/* Logo */}
      <div
        className="cursor-pointer flex hover:opacity-80 transition-opacity duration-200"
        onClick={() => handleNavigation("/")}
      >
        <img className="w-[75px] h-[60px]" src={Logo} alt="Logo" />
        <h2 className="text-[16px] flex items-center font-bold leading-tight relative right-[15px]">
          Money Rate
          <br />
          Finder
        </h2>
      </div>

      {/* Desktop Navigation */}
      <div className="hidden md:flex gap-8 lg:gap-10 text-[15px] font-bold items-center">
        {options.map((item) => (
          <p
            key={item.id}
            className="cursor-pointer text-[15px] hover:text-[#7B3BCC] transition-colors duration-200"
            onClick={() => handleNavigation(item.route)}
          >
            {item.label}
          </p>
        ))}
        {/* <Button
          btnText="Boost Rankings & Revenue"
          classes="bg-white px-6 py-2 text-xs lg:text-sm border-2 border-customBlue text-customBlue rounded-lg font-bold hover:bg-[#7B3BCC] hover:text-white transition-colors duration-200"
        /> */}
      </div>

      {/* Mobile Navigation Toggle */}
      <div className="md:hidden flex items-center">
        <button
          onClick={handleMenuToggle}
          aria-label="Toggle navigation menu"
          className="text-[#7B3BCC] hover:text-[#1a43b5] transition-colors duration-200"
        >
          {isMobileMenuOpen ? <IoClose size={24} /> : <IoMenu size={24} />}
        </button>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div className="absolute top-[68px] left-0 w-full bg-white z-10 shadow-lg p-5 md:hidden">
          {options.map((item) => (
            <p
              key={item.id}
              className="py-3 text-[15px] font-semibold text-gray-700 cursor-pointer hover:text-[#2153E8] transition-colors duration-200"
              onClick={() => handleNavigation(item.route)}
            >
              {item.label}
            </p>
          ))}
          {/* <Button
            label="Boost Rankings & Revenue"
            classes="w-full mt-4 bg-white px-6 py-2 text-xs border-2 border-customBlue text-customBlue rounded-lg font-bold hover:bg-[#2153E8] hover:text-white transition-colors duration-200"
          /> */}
        </div>
      )}
    </div>
  );
};

export default Header;
